import Logout from './logout.ui.jsx';
import { connect } from 'react-redux';
import { logout } from '../actions/user';
import {
    selectOfflineContentIds,
    selectDownloadingContentIds,
} from '../selectors/offline.js';
import { routeToTerm } from '../actions/route';

function mapStateToProps(state, props) {
    return {
        localContent: selectOfflineContentIds(state),
        downloadingContent: selectDownloadingContentIds(state),
        termId: props.params.termId,
    };
}

export default connect(
    mapStateToProps,
    {
        logout,
        routeToTerm,
    }
)(Logout);



// WEBPACK FOOTER //
// ./src/components/logout.jsx